import API from '@/api/intermodality/order';
// import CONTRACTAPI from '@/api/intermodality/contract';
export default {
  data() {
    return {
      carList: [],
      weightList: [],
      serviceProviderList: [], //服务供方下拉选择数据
      routeNameList: [], //线路名下拉数据
      numberUnitList: [], // 件数单位
      weightUnitList: [], // 重量单位
      goodsList: [], // 商品下拉数据
      volumeUnitList: [], // 体积单位
      containerTypeList: [], // 箱型列表
      serviceMethodsList: [], // 运输服务方式列表
      provinceList: [],
      productParentList: [], //运输服务商品名称下拉列表
      productChildList: [], //运输服务商品子类名称下拉列表
      importProductParent: [], //获取到的所有商品父类的数据
      importRouteName: {}, //获取到的所有线路名称数据
      // boxList: [{ type: '', number: '' }], // 箱型 默认由一个
    };
  },
  methods: {
    async getParentProductList(extraData = {}) {
      const postData = {
        parentProductStatus: 'ZT03',
        adminFlag: this.userInfo.adminFlag,
        selectCompanyCode: this.userInfo.companyCode,
        contractCode: this.contractCode,
        ...extraData,
      };
      console.log(Object.keys(extraData).length, extraData);
      let res = await this.$axios.post(API.PRODUCT_PARENT_NAME, postData);
      if (res.data.code == 0) {
        if (Object.keys(extraData).length != 0) {
          this.productChildList = res.data.data.map((item) => {
            return {
              ...item,
              value: item.productDetailCode,
              label: item.productDetailCode,
            };
          });
        } else {
          this.importProductParent = res.data.data.length ? res.data.data : [];
          this.productParentList = res.data.data.map((item) => {
            return {
              ...item,
              value: item.productParentCode,
              label: item.productParentName,
            };
          });
        }
      }
    },
    // 合同列表
    async getContractList() {
      const params = {
        adminFlag: this.userInfo.adminFlag,
        contractType: '0',
        isCS: 'C',
      };
      await this.$axios.post(API.CUSTOMER_CONTRACT, params).then((res) => {
        if (res.data.code === 0) {
          (res.data.data || []).forEach((contract) => {
            this.contractList.push({
              label: contract.contractName,
              value: contract.contractCode,
            });
          });
        }
      });
    },
    async getButtonList() {
      await this.getButtons().then((e) => {
        this.menuButtonList = e.length > 0 ? e : this.defaultMenuList;
        this.getColumnInfo();
      });
    },
    async getColumnInfo() {
      await this.getColumnList(this.columnListDefault).then((res) => {
        console.log(res, '111');
        this.columnList = this.columnListDefault;
      });
    },
    // 件数单位列表
    getUnitList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-QTY-UNIT',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          console.log(res, 'numberUnitList');
          if (res.data.code === 0) {
            this.numberUnitList = res.data.data || [];
          }
        });
    },
    // 重量单位列表
    getWeightUnitList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-WEIGHT-UNIT',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          console.log(res, 'weightUnitList');
          if (res.data.code === 0) {
            this.weightUnitList = res.data.data || [];
          }
        });
    },
    // 体积单位列表
    getVolumeUnitList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-VOLUME-UNIT',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            console.log(res.data.data, 'volumeUnitList');
            this.volumeUnitList = res.data.data || [];
          }
        });
    },
    // 箱型单位列表
    getContainerTypeList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-CONTAINER-TYPE',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          console.log(res, 'CONTAINER-TYPE');
          if (res.data.code === 0) {
            this.containerTypeList = res.data.data || [];
          }
        });
    },
    // 车型列表
    getCarList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-CAR-TYPE',
          tenantCode: this.userInfo.tenantCode,
          selectCompanyCode: this.userInfo.companyCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.carList = res.data.data || [];
          }
        });
    },
    // 吨位列表
    getWeightList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-GROSS-WEIGHT-UNIT',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.weightList = res.data.data || [];
          }
        });
    },
    // 产品列表
    getProductList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-PRODUCT-TYPE',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.productList = res.data.data || [];
          }
        });
    },
    // 服务列表
    getServiceList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-SERVICE-TYPE',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.serviceList = res.data.data || [];
          }
        });
    },
    // 获取服务供方数据
    getServiceProviderList() {
      const params = {
        adminFlag: this.userInfo.adminFlag,
        contractStatus: 'ZT03',
        isCS: 'S',
      };
      this.$axios.post(API.SERVICE_DATA, params).then((res) => {
        console.log(res, '-=-=-=-=-=111111111');
        if (res.data.code === 0) {
          const data = res.data.data || [];
          let obj = {};
          this.serviceProviderList = data.reduce(function (item, next) {
            obj[next.supplierCode] ? '' : (obj[next.supplierCode] = true && item.push(next));
            return item;
          }, []);
          // 去重
          // this.serviceProviderList = array;
        }
      });
    },
    // 获取线路名称
    getRouteNameList() {
      const params = {
        adminFlag: this.userInfo.adminFlag,
      };
      this.$axios.post(API.ROUTE_NAME, params).then((res) => {
        if (res.data.code === 0) {
          let list = res.data.data || [];
          this.routeNameList = list;
        }
      });
    },
    async getRouteNameListFromContract(contractCode) {
      let params = {};
      params.contractCode = contractCode;
      var res = await this.$axios.post('/sales/mto/contract/getContractAllRoutesCargo', params);
      if (res.data.code === 0) {
        let rawList = res.data?.data?.routes || [];
        // 在导入时，传入获取到的线路列表
        this.importRouteName = res.data?.data;
        if (rawList && rawList.length != 0) {
          this.routeNameList = rawList.map((item) => {
            item.name = item.routeName;
            item.code = item.routeCode;
            return item;
          });
          console.log('processedRoutes', this.routeNameList);
        }
      } else {
        this.$message({ showClose: true, message: res.data.msg, type: 'error' });
      }
      return [];
      // const params = {
      //   adminFlag: this.userInfo.adminFlag,
      // };
      // this.$axios.post(API.ROUTE_NAME, params).then((res) => {
      //   if (res.data.code === 0) {
      //     let list = res.data.data || [];
      //     this.routeNameList = list;
      //   }
      // });
    },
    // 获取商品列表
    getGoodsList() {
      const params = {
        adminFlag: this.userInfo.adminFlag,
      };
      this.$axios.post(API.GOODS_NAME, params).then((res) => {
        if (res.data.code === 0) {
          this.goodsList = res.data.data || [];
        }
      });
    },
    // 获取运输服务方式
    getServiceMethodsList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-SHIPMENT-SERVICE-METHOD',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.serviceMethodsList = res.data.data || [];
          }
        });
    },
    // 获取省份方式
    getProvinceList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'province',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          console.log(res, '1233333');
          if (res.data.code === 0) {
            this.provinceList = res.data.data || [];
          }
        });
    },
    // 获取站点
    getStationList() {
      this.$axios.post(API.STATION_API, {}).then((res) => {
        console.log(res, '-0-0-0-0');
        if (res.data.code === 0) {
          let list = res.data.data || [];
          this.stationList = list.filter((it) => it.stationProvinceCode);
          console.log(this.stationList, 'this.stationList');
        }
      });
    },
  },
};
